// Webpack Imports
import 'bootstrap';
import 'slick-carousel';

require('./inc/animate.js');
require('./inc/header.js');
require('./inc/gallery.js');

